import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay, FiVolume2 } = FiIcons;

function SoundCard({ sound, onPlay, isPlaying }) {
  const [isLocalPlaying, setIsLocalPlaying] = useState(false);

  const handleClick = () => {
    setIsLocalPlaying(true);
    onPlay();
    // Reset the playing state after a short duration for visual feedback
    setTimeout(() => {
      setIsLocalPlaying(false);
    }, 1000);
  };

  return (
    <motion.div
      className={`bg-white rounded-xl shadow-sm border-2 transition-all duration-300 cursor-pointer overflow-hidden w-30 relative ${
        isLocalPlaying 
          ? 'border-[#57838d] shadow-lg scale-105' 
          : 'border-gray-200 hover:border-[#b5c9c8] hover:shadow-md'
      }`}
      onClick={handleClick}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {/* Image - Fills entire red outlined space */}
      <div className="relative h-20 bg-gray-50 overflow-hidden rounded-t-xl">
        <img 
          src={sound.image} 
          alt={sound.example}
          className="w-full h-full object-cover"
        />
        
        {/* Play Overlay */}
        <div className={`absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center transition-opacity duration-300 ${
          isLocalPlaying ? 'opacity-100' : 'opacity-0 hover:opacity-100'
        }`}>
          <div className="bg-white rounded-full p-2 shadow-lg">
            <SafeIcon 
              icon={isLocalPlaying ? FiVolume2 : FiPlay} 
              className={`text-base ${isLocalPlaying ? 'text-[#57838d]' : 'text-[#445a68]'}`}
            />
          </div>
        </div>

        {/* Playing indicator */}
        {isLocalPlaying && (
          <motion.div
            className="absolute top-1 left-1 bg-[#57838d] text-white rounded-full p-1"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <SafeIcon icon={FiVolume2} className="text-sm" />
          </motion.div>
        )}
      </div>

      {/* Content - Scaled proportionally */}
      <div className="p-2.5">
        <div className="text-center">
          <div className="text-xl font-bold text-[#445a68] mb-1">
            /{sound.symbol}/
          </div>
          <div className="text-sm font-semibold text-black">
            {sound.example}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default SoundCard;